import { details } from 'redevConfig'

const list = (details && details.list) || ''
const declareDetailView = list ? require(`redevelopment/outputManage/details/${list.templateName}`) : require('./views/declareDetail.html')
export default {
    base: {
        state: 'outputManage.stock.declareDetail',
        config: {
            url: '/declareDetail',
            abstract: true,
            controller: 'declareDetailRootCtrl',
            template: '<div ui-view></div>',
        },
    },
    list: {
        state: 'outputManage.stock.declareDetail.list',
        config: {
            url: '/list',
            template: declareDetailView,
            controller: 'declareDetailCtrl',
            title: '明细查询',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/details/routers.js